import React from "react";

import styles from "../../offer/OfferContents.module.scss";

type Props = {
  question?: string;
  answer?: string;
};

export const ConfirmationContent: React.FC<Props> = ({ question, answer }) => {
  return (
    <div className={styles["f-adminOfferContent"]}>
      <h2 className={styles["f-adminOfferContent__title"]}>
        応募者への質問事項
      </h2>
      <div className={styles["f-adminOfferContent__content"]}>
        <div className={styles["f-adminOfferContent__content-type"]}>
          {question}
        </div>
        <p>{answer}</p>
      </div>
    </div>
  );
};
